// extracted by mini-css-extract-plugin
export default {"zoomModal":"w4-z"};